<template>
	<div>
		<div class="input-group">
	        <tags-input v-model="query" :placeholder="__('translations.label.search_placeholder')"
	        	:tags="tags"
	        	:autocomplete-items="autocompletedTags"
	        	:autocomplete-min-length="1"
	        	:validation="validation"
	        	:max-tags="maxTags"
	        	@tags-changed="update"
	        	@before-adding-tag="beforeAddingTag"
	        	:is-duplicate="isDuplicate" />
	        	
	        <div class="input-group-append ml-0">
	        	<div v-if="displaySearchOptions" class="d-flex search-option">
		        	<div class="align-self-center mr-1">
						<div class="btn" @click="displayInfo = !displayInfo">
							<i class="fas fa-question" :class="{'active' : displayInfo}"></i>
						</div>
					</div>
        		</div>
        		
				<button class="btn btn-primary" @keyup.enter="search" type="button" :disabled="tags.length == 0" @click="search">
				    <span v-if="!isSearching"><i class="fas fa-search" style="vertical-align: middle;"></i></span>
					<span v-else>
						<div class="spinner-border spinner-border-sm" role="status" style="vertical-align: middle;">
							<span class="sr-only">Loading...</span>
						</div>
					</span>
				</button>
			</div>
		</div>
		
		<div v-if="displaySearchOptions && displayInfo" class="alert alert-primary alert-dismissible fade show mt-4" role="alert">
			<h5 class="alert-heading">{{ __('translations.message.how_to_search') }}</h5>
			<div class="d-flex flex-row">
				<span class="mr-2">{{ __('translations.message.search_instruction_1') }}</span>
				<h5 class="mb-0 align-self-center"><span class="badge badge-primary">{{ __('translations.message.or') }}</span></h5>
				<span class="ml-2">{{ __('translations.message.search_instruction_2') }}</span>
			</div>
			<hr>
			<h5 class="alert-heading">{{ __('translations.message.search_exclustion_title') }}</h5>
			<div>{{ __('translations.message.search_exclustion_instruction') }}</div>
			<hr>
			<p class="mb-0"><small>{{ __('translations.message.search_instruction_footer') }}</small></p>
			<button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="displayInfo = false">
			    <span aria-hidden="true">&times;</span>
			</button>
		</div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'
import VueTagsInput from '@johmun/vue-tags-input';
import _ from 'lodash';

export default {
    name: "Searchbar",
    props: {
    	maxTags: Number,
    	focusOnRender: Boolean,
    	displaySearchOptions: Boolean
   	},
    data() {
        return {
            query: '',
            tags: [],
            autocompletedTags: [],
            validation: [{
                classes: 'search-keyword',
                rule: tag => typeof tag.id === 'undefined'
			}],
			displayInfo: false,
        }
    },
    components: {
    	'tags-input': VueTagsInput
    },
    computed: {
		...mapGetters([
			'isSearching'
		]),
	},
    watch: {
        query: {
            handler: _.debounce(function (value) {
            	if(value.length > 0 && value !== '-') {
           			this.getAutocompleteTags();
            	} else {
            		this.autocompletedTags = [];
            	}
            }, 200)
        }
    },
    created() {
    	if(this.focusOnRender) {
    		this.focusSearchInput();
    	}
    },
    methods: {
        update(newTags) {
            this.autocompletedTags = [];
            this.tags = newTags;
            
            if (this.tags.length > 0) {
            	this.search();
        	} else {
        		if(this.$store.state.cancelSourceForSearch) {
        			this.$store.state.cancelSourceForSearch.cancel('Cancelling the search request because there are no tags/keywords entered.');
        		}
        		this.$store.commit('SET_CANCEL_SOURCE_FOR_SEARCH', null);
        		
        		this.$store.state.isSearching = false;
        		this.$store.state.isSearched = false;
       			this.$store.commit('SET_CANVASES', []);
        	}
            
            this.focusSearchInput();
        },
        search() {
        	const searchTags = this.tags.filter(tag => { return !tag.classes || !tag.classes.includes('excluded-tag'); });
			
			// Search only if there are "positive" tags.
			if(searchTags.length > 0) {
				this.$store.state.isSearching = true;
	        	this.$store.state.isSearched = false;
	        	
				const excludedTags = this.tags.filter(tag => { return tag.classes && tag.classes.includes('excluded-tag'); });
				
				this.$store.commit('SET_SEARCH_PARAMS', {'tags': searchTags, 'excludedTags': excludedTags, 'routeParams': this.$route.params});
				this.$store.dispatch('GLOBAL_SEARCH');
			}
        },
        getAutocompleteTags() {
			axios.post('/autocomplete', {'query': this.query, 'routeParams': this.$route.params}).then(response => {
				this.autocompletedTags = response.data.map(data => {
					return {
                       	id: data.wikidata_id,
                       	text: data.wikidata_label,
                       	classes: 'autocompleted-tag'
                	};
				});
			});
        },
        focusSearchInput() {
        	Vue.nextTick(function() {
        		$('input.ti-new-tag-input').focus();
       		});
        },
        isDuplicate(tags, tag) {
        	const tagIds = tags.filter(({ id }) => id === tag.id);
			return tagIds.map(({ text }) => text).indexOf(tag.text) !== -1;
       	},
       	beforeAddingTag(event) {
       		if(this.query.charAt(0) === '-') {
       			if(event.tag.classes) {
       				event.tag.classes += ' excluded-tag';
       			} else {
       				event.tag.classes = 'excluded-tag';
       			}
       		}
       		
       		event.addTag();
       	}
    },
}
</script>